<template>
  <div class="full-page-error" v-cy="{ errCode, errMessage, errStatus }"/>
</template>

<script>
const DEFAULTS = {
  '404': {
    title: 'Not Found',
    message: 'Something was not found',
  },
  '500': {
    title: 'Internal Server Error',
    message: 'Looks like we\'re having some server issues',
  },
  '503': {
    title: 'Service Unavailable',
    message: 'Looks like we\'re having some server issues',
  },
};

export default {
  props: {
    err: {
      type: [ Error, Object ],
      default: () => null,
    },
    errConfig: {
      type: Object,
      default: () => ({}),
    },
  },
  mounted() {
    if (this.err) {
      this.$notifyFatalErr(this.err, this.errConfig);
    } else if (this.status) {
      this.$notifyFatalErr(null, { ...DEFAULTS[`${this.status}`], ...this.errConfig });
    } else if (this.$route.name === 'Error404') {
      this.$notifyFatalErr(null, { ...DEFAULTS['404'], ...this.errConfig });
    } else {
      this.$notifyFatalErr(null, {
        title: 'An unknown error occurred',
        message: 'You have reached the error page but no error context was passed through. Please refresh your page, or click the logo to return home.',
        ...this.errConfig,
      });
    }
  },
  computed: {
    errCode() {
      const { code } = this.err || {};
      return code || null;
    },
    errMessage() {
      const { message } = this.err || {};
      return message || null;
    },
    errStatus() {
      if (this.$route.name === 'Error404') {
        return 404;
      } else {
        const { status, statusCode } = this.err || {};
        return status || statusCode || null;
      }
    },
  },
};
</script>

<style lang="scss">
.full-page-error {
  height: 200px;
}
<style>



// WEBPACK FOOTER //
// src/views/Error.vue